import React from "react";
import classes from "./AttachmentItem.scss";
import classNames from "classnames";
import {
  Camera3D,
  Record3D,
  Video3D,
  Files3D,
  Notes3D,
  Link3D,
  Workbook3D,
  Food3D,
  Nap3D,
  Toilet3D,
  Document3D,
} from "@toddle-edu/ds-icons";
import {
  isPortfolioParityEnabledAndIsJournalRoute,
  onEnterOrSpaceKeyDownWithPreventDefault,
} from "Post/utils";
import _ from "lodash";
import { isTabletByUserAgent } from "Utils";

class AttachmentItem extends React.PureComponent {
  getAttachmentIcon = () => {
    const { item: { type } = {}, isDropdownOpen } = this.props;
    const svgIconContainer = classNames(
      { [classes.svgIcon]: true },
      { [classes.activeIconContainer]: isDropdownOpen }
    );
    switch (type) {
      case "PHOTO":
        return (
          <Camera3D height={132} width={132} className={svgIconContainer} />
        );
      case "VOICE":
        return (
          <Record3D height={132} width={132} className={svgIconContainer} />
        );
      case "VIDEO":
        return (
          <Video3D height={132} width={132} className={svgIconContainer} />
        );
      case "FILE":
        return (
          <Files3D height={132} width={132} className={svgIconContainer} />
        );
      case "NOTE":
        return (
          <Notes3D height={132} width={132} className={svgIconContainer} />
        );
      case "LINK":
        return <Link3D height={132} width={132} className={svgIconContainer} />;
      case "WORKBOOK":
        return (
          <Workbook3D height={132} width={132} className={svgIconContainer} />
        );
      case "ACTIVITY_FOOD":
        return <Food3D height={132} width={132} className={svgIconContainer} />;
      case "ACTIVITY_NAP":
        return <Nap3D height={132} width={132} className={svgIconContainer} />;
      case "ACTIVITY_TOILET":
        return (
          <Toilet3D height={132} width={132} className={svgIconContainer} />
        );
      case "TODDLE_DOC":
        return (
          <Document3D height={132} width={132} className={svgIconContainer} />
        );
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.isFocused && !prevProps.isFocused) {
      if (this.attachmentItemRef.current) {
        this.attachmentItemRef.current?.focus();
      }
    }
  }

  getContainerClassName = () => {
    return classNames(classes.container, {
      [classes.tabletContainer]: isTabletByUserAgent(),
    });
  };

  render() {
    const {
      item: { color, title, type } = {},
      onAttachmentSelected = () => {},
      forwardedRef,
    } = this.props;

    const onAttachmentSelectedLocal = () => {
      onAttachmentSelected(type);
    };

    const onHandleKeyDown = e => {
      !isButtonDropdownType &&
        onEnterOrSpaceKeyDownWithPreventDefault(e, onAttachmentSelectedLocal);
    };
    const isButtonDropdownType = _.includes(["PHOTO", "VIDEO", "FILE"], type);

    const attachmentStyle = {
      backgroundColor: color,
    };
    const containerClassName = this.getContainerClassName();
    return isButtonDropdownType &&
      isPortfolioParityEnabledAndIsJournalRoute() ? (
      <div
        className={containerClassName}
        ref={forwardedRef}
        onClick={onAttachmentSelected.bind(null, type)}
        data-test-id={"attachmentitemtypeselection-" + type}
        tabIndex={isButtonDropdownType ? -1 : 0}
        onKeyDown={onHandleKeyDown}
        aria-label="attachmentItem"
      >
        <div
          className={classes.iconContainer}
          style={{ backgroundColor: color }}
        >
          {this.getAttachmentIcon()}
        </div>
        <div className={classes.iconText}>{title}</div>
      </div>
    ) : (
      <button
        className={containerClassName}
        ref={forwardedRef}
        onClick={onAttachmentSelected.bind(null, type)}
        data-test-id={"attachmentitemtypeselection-" + type}
        tabIndex={isButtonDropdownType ? -1 : 0}
        onKeyDown={onHandleKeyDown}
      >
        <div className={classes.iconContainer} style={attachmentStyle}>
          {this.getAttachmentIcon()}
        </div>
        <div className={classes.iconText}>{title}</div>
      </button>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <AttachmentItem {...props} forwardedRef={ref} />
));
